import m from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'

import s from './input-checkbox.module.scss'

const InputCheckbox = initMithrilComponent<{
	label?: string
	checked?: boolean
	indeterminate?: boolean
	id?: string
	disabled?: boolean
	class?: string
	onchange?: (checked: boolean) => void
	onfocus?: () => void
	onblur?: () => void
}>()

InputCheckbox.view = (vnode) => {
	const {
		label = '',
		checked = false,
		indeterminate = false,
		id = crypto.randomUUID(),
		disabled = false,
		class: add_class,
		onchange: onChangeCallback,
		onfocus,
		onblur,
	} = vnode.attrs

	return m('label', { class: clsx(s.input_checkbox, add_class, disabled && s.disabled) }, [
		m('div', { class: s.check_container }, [
			m('input', {
				type: 'checkbox',
				class: s.input,
				onchange: (e: InputEvent) => {
					const is_checked = (e.currentTarget as HTMLInputElement)?.checked ?? false

					onChangeCallback?.(is_checked)
				},
				checked,
				indeterminate,
				id,
				disabled,
				onfocus,
				onblur,
			}),
			m('span', { class: indeterminate ? s.indeterminate : s.checkmark }),
		]),
		label.trim().length > 0 && m('span', { class: s.label }, label.trim()),
	])
}

export default InputCheckbox
